import {Comparator} from "../../../types/GenericTypes";
import {reverse} from "../../../js/util/UtilFunctions";
import {RiskRow} from "../models/risk-model/RiskSummary";

export function orderRowsByName(): Comparator<RiskRow> {
    return (a, b) => a.name.localeCompare(b.name);
}

export function orderByCurrentStel(): Comparator<RiskRow> {
    return (a, b) => a.currentStel - b.currentStel;
}

export function orderByInitialMargin(): Comparator<RiskRow> {
    return (a, b) => a.currentCbpl - b.currentCbpl;
}

export function orderByMargin(): Comparator<RiskRow> {
    return (a, b) => a.currentAsxMargin - b.currentAsxMargin;
}

export const orderByMarginDec = reverse(orderByMargin());

export const orderByCurrentStelDec = reverse(orderByCurrentStel());

export const orderByInitialMarginDec = reverse(orderByInitialMargin());
